/**
 * Baacal — Judge.me Featured Carousel (safe draft fixes only).
 * Theme 162540486909.
 *
 * Do NOT reorder/move carousel DOM nodes — that breaks Judge.me's slider
 * (blank track / zero-height slides). Dupes → Judge.me featured curation later.
 *
 * Keeps: strip #judgeme_product_reviews off real PDP product links.
 * Sharpens: product thumbs (_168x168 / small CDN widths) → ~400px so CSS
 * 148×185 display (and retina) is not upscaling blur.
 */
(function () {
  var REVIEW_HASH = '#judgeme_product_reviews';
  var ATTR_DONE = 'data-baacal-jdgm-links';
  // 400 covers 148 CSS px @2x; retina attr gets 800 (Judge.me puts _168x168 in data-src-retina).
  var TARGET_W = 400;
  var TARGET_RETINA_W = 800;
  var scheduled = false;

  function stripReviewAnchors(root) {
    root = root || document;
    root.querySelectorAll('a.jdgm-carousel-item__product').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf(REVIEW_HASH) === -1) return;
      try {
        var url = new URL(href, location.origin);
        if (url.hash !== REVIEW_HASH) return;
        if (url.pathname.indexOf('/products/') === 0) {
          a.setAttribute('href', url.pathname + url.search);
        }
      } catch (e) {
        /* ignore malformed hrefs */
      }
    });
  }

  /**
   * Rewrite Shopify CDN sized filenames / width params.
   * Handles _168x168., _100x., ?width=168 — leaves already-large URLs alone.
   * @param {string} url
   * @param {number} minW
   */
  function sharpenUrl(url, minW) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('data:') === 0) return url;
    minW = minW || TARGET_W;

    var out = url;

    // _WxH before crop/ext/@2x (e.g. _168x168.jpg, _168x168_crop_center.jpg)
    out = out.replace(/_(\d+)x(\d+)(?=_|@|\.|\?|$)/g, function (m, w, h) {
      if (parseInt(w, 10) >= minW) return m;
      return '_' + minW + 'x';
    });

    // Width-only _Nx (e.g. _168x.jpg, _168x_crop_center.jpg)
    out = out.replace(/_(\d+)x(?=_|@|\.|\?|$)/g, function (m, w) {
      if (parseInt(w, 10) >= minW) return m;
      return '_' + minW + 'x';
    });

    out = out.replace(/([?&]width=)(\d+)/gi, function (m, p, w) {
      if (parseInt(w, 10) >= minW) return m;
      return p + String(minW);
    });

    return out;
  }

  function sharpenSrcset(value, minW) {
    if (!value) return value;
    return value
      .split(',')
      .map(function (part) {
        var bits = part.trim().split(/\s+/);
        if (bits[0]) bits[0] = sharpenUrl(bits[0], minW);
        return bits.join(' ');
      })
      .join(', ');
  }

  function setIfChanged(el, attr, next) {
    if (!next) return;
    var cur = el.getAttribute(attr);
    if (cur === next) return;
    el.setAttribute(attr, next);
  }

  function sharpenProductImages(root) {
    root = root || document;
    root.querySelectorAll('img.jdgm-carousel-item__product-image').forEach(function (img) {
      ['src', 'data-src', 'data-original', 'data-lazy-src'].forEach(function (attr) {
        var v = img.getAttribute(attr);
        if (!v) return;
        setIfChanged(img, attr, sharpenUrl(v, TARGET_W));
      });
      // Judge.me stores the tiny thumb in data-src-retina; raise to 800 for DPR≥2.
      var retina = img.getAttribute('data-src-retina');
      if (retina) setIfChanged(img, 'data-src-retina', sharpenUrl(retina, TARGET_RETINA_W));

      ['srcset', 'data-srcset'].forEach(function (attr) {
        var v = img.getAttribute(attr);
        if (!v) return;
        setIfChanged(img, attr, sharpenSrcset(v, TARGET_W));
      });

      // Promote lazy attrs to src when empty so thumbs aren't stuck unloaded,
      // and so retina lazy-load cannot keep a leftover _168x168 currentSrc.
      var preferred =
        img.getAttribute('data-src-retina') || img.getAttribute('data-src') || '';
      if (preferred) {
        var curSrc = img.getAttribute('src');
        if (!curSrc) {
          setIfChanged(img, 'src', preferred);
        } else {
          var wm = curSrc.match(/_(\d+)x/);
          if (wm && parseInt(wm[1], 10) < TARGET_W) {
            setIfChanged(img, 'src', preferred);
          } else {
            var sharpCur = sharpenUrl(curSrc, TARGET_W);
            if (sharpCur !== curSrc) setIfChanged(img, 'src', sharpCur);
          }
        }
      }
    });
  }

  function fix() {
    var carousels = document.querySelectorAll('.jdgm-carousel');
    if (!carousels.length) return;
    stripReviewAnchors(document);
    sharpenProductImages(document);
    Array.prototype.forEach.call(carousels, function (el) {
      el.setAttribute(ATTR_DONE, '1');
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      fix();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('jdgm.doneInitialized', schedule);
  window.addEventListener('load', schedule);

  // Watch for carousel inject + lazy src swaps; disconnect once thumbs look sharp.
  var obs = new MutationObserver(function (mutations) {
    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes') {
        var t = m.target;
        if (
          t &&
          t.nodeType === 1 &&
          t.classList &&
          t.classList.contains('jdgm-carousel-item__product-image')
        ) {
          relevant = true;
          break;
        }
        continue;
      }
      var nodes = m.addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (
          (n.matches &&
            n.matches(
              '.jdgm-carousel, .jdgm-carousel-item, img.jdgm-carousel-item__product-image'
            )) ||
          (n.querySelector &&
            n.querySelector(
              '.jdgm-carousel-item__product, img.jdgm-carousel-item__product-image'
            ))
        ) {
          relevant = true;
          break;
        }
      }
      if (relevant) break;
    }
    if (!relevant) return;
    schedule();
    // Stop once we have product images and none still use tiny Shopify thumbs.
    var imgs = document.querySelectorAll('img.jdgm-carousel-item__product-image');
    if (!imgs.length) return;
    var stillTiny = false;
    for (var k = 0; k < imgs.length; k++) {
      var src =
        imgs[k].getAttribute('src') ||
        imgs[k].getAttribute('data-src') ||
        imgs[k].getAttribute('data-src-retina') ||
        '';
      var wm = src.match(/_(\d+)x/);
      if (wm && parseInt(wm[1], 10) < TARGET_W) {
        stillTiny = true;
        break;
      }
    }
    if (!stillTiny && document.querySelector('a.jdgm-carousel-item__product')) {
      obs.disconnect();
    }
  });
  obs.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'],
  });
})();
